import { Loadable } from '@/components/loaders';
import { EDataSourceCategory } from '@/models/dataSource';
import { useGetDataSourceTypesQuery } from '@/services/dataSources';
import { FC } from 'react';
import { DataSourcesGrid } from './DataSourceGrid';

export const DataSourceSection: FC = () => {
  const { isFetching, data: sources } = useGetDataSourceTypesQuery();
  const availableSources = sources?.filter(
    (source) => source.category === EDataSourceCategory.CODE || 
             source.category === EDataSourceCategory.FILE || 
             source.category === EDataSourceCategory.CRM
  );

  return (
    <Loadable isLoading={isFetching}>
      {availableSources && (
        <DataSourcesGrid dataSources={availableSources} />
      )}
    </Loadable>
  );
};